import React, { useEffect } from "react"
import { Container, Row, Col, Button } from "reactstrap"
import * as s from "./style.module.css"
import Dots from "../Dots/index"
import useLabels from "../../utils/useLabels"

import labels from "../Summary2023/const"
import Numbers from "../Numbers"
import Text from "../Text"
import Workshops, { Workshop } from "../Workshops"
import Mentors from "../Mentors"
import Partners, { PartnersCard } from "../Partners"
import WorkshopsFull from "../WorkshopsFullDesc"
import MentorsFull from "../MentorsWithDesc"
import Gadget from "../Gadget"
import Localization from "../Localization"

export default function Summary2023({ lang }) {
  const t = useLabels(labels, lang)

  return (
    <div className={s.root}>

      <Container className="mb-5">

        <div className={s.header}>
          <h2>{t.data2023.title}</h2>
          <div className={s.divider} />
        </div>

        <div className="text-left" dangerouslySetInnerHTML={{ __html: t.data2023.description }}>
        </div>

        <Numbers />

        {/* Projects section */}
        <div className="mt-5">
          <div className={s.header}>
            <h2>{t.projects2023.projectsTitle}</h2>
            <div className={s.divider} />
          </div>

          <p
            className={s.summaryText}
            dangerouslySetInnerHTML={{ __html: t.projects2023.summary }}
          />
        </div>

      </Container>

      <div className={[s.bgWrapper, "px-5"].join(" ")}>
        <div className="position-relative">
          <Col>
            <div className={[s.project, s.winners, s.highlight].join(" ")}>
              <div className="d-flex flex-column">
                <img alt="" className={[s.winnersImg].join(" ")} src={t.projects2023.winners.image} />
                <div className={s.dotsWrapper2}>
                  <Dots x={4} y={4} color="black" />
                </div>
                <div className="w-100">
                  <h1 className={s.winnersTitle}>{t.projects2023.winners.name}</h1>
                  <h5 className={[s.place, "text-center"].join(" ")}>
                    {t.projects2023.winners.place}
                  </h5>

                  <div
                    className={s.text}
                    dangerouslySetInnerHTML={{ __html: t.projects2023.winners.text }}
                  />
                </div>
              </div>
            </div>
          </Col>

          <Row xs={1} md={2} className="justify-content-center">
            {t.projects2023.projects.map(project => (
              <Col className="mb-4">
                <Project {...project} />
              </Col>
            ))}
          </Row>
        </div>
      </div>

      <section id="workshop-2023">
        <WorkshopsFull workshops={t.workshops2023} />
      </section>

      <section id="mentors-2023">
        <MentorsFull mentors={t.mentors2023} />
      </section>

      <section id="partners-2023">
        <div className={s.root}>
          <Container className={s.container}>
            <div className={s.header}>
              <h2>{t.partners2023.title}</h2>
              <div className={s.divider} />

              {t.partners2023.partners.logos.map(({ title, elements }) => (
                <PartnersCard title={title} elements={elements} />
              ))}

              <img
                className={s.line}
                src={require("../Text/icons/line.svg").default} />

              {t.partners2023.partners2023Others.logos.map(({title, elements}) => (
                <PartnersCard title={title} elements={elements} />
              ))}
            </div>
          </Container>
        </div>
      </section>

    </div>
  )
}

function Project({ text, name, image, place, posX, posY }) {
  const dostStyle = {
    position: "absolute",
    top: posX,
    left: posY,
    transform: "scale(1.6)",
    zIndex: 0
  }


  return (
    <div
      className={[s.project, s.highlight].join(" ")}
    >
      <div className="d-flex">
        {image &&
        <div className={s.imgWrapper}>
            <img alt="" className={s.img} src={image} />
            {/*<div style={dostStyle}>*/}
            {/*  <Dots x={4} y={4} color="black" />*/}
            {/*</div>*/}
        </div>
        }
      </div>

      <h4 className={s.projectTitle}>{name}</h4>
      <h5 className={s.place}>{place}</h5>
      <p className={s.text} dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  )
}
